import Api from "./Api";



const getMembers=()=>{
return Api().get(`/team-member/`);
}

const deleteMember = (id) => {
    return Api().delete(`team-member/${id}`);
  };


const putMembers = (data,id) => {
  return Api().put(`/team-member/${id}`,data ,{
    headers: {
      "Content-Type": `multipart/form-data; boundary=${data._boundary}`,
    },
});
}

const postMembers = ( data) => {
  return Api().post(`/team-member/`, data ,{
  headers: {
    "Content-Type": `multipart/form-data; boundary=${data._boundary}`,
  },
});
}

const getMembersIndividual = (_id) => {
  return Api().get(`/team-member/${_id}`);
};



export{putMembers, postMembers, 
  getMembersIndividual, getMembers, deleteMember
};



